var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found-container"},[_c('h1',{staticClass:"not-found-title"},[_vm._v("404")]),_c('p',{staticClass:"not-found-description"},[_vm._v("很抱歉，您访问的页面不存在。")]),_c('router-link',{staticClass:"not-found-link",attrs:{"to":"/niuhui"}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }